import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE } from "../config";


const API = `${API_BASE}/geo`;


export default function AdminGeo() {
  // Form Inputs
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [panchayatName, setPanchayatName] = useState("");

  // Dropdown Data
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);

  // Selected IDs
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");

  // Load states at page open
  useEffect(() => {
    fetchStates();
  }, []);

  const fetchStates = async () => {
    const res = await axios.get(`${API}/states`);
    setStates(res.data);
  };

  const fetchDistricts = async (stateId) => {
    const res = await axios.get(`${API}/districts/${stateId}`);
    setDistricts(res.data);
  };

  const fetchBlocks = async (districtId) => {
    const res = await axios.get(`${API}/blocks/${districtId}`);
    setBlocks(res.data);
  };

  // -----------------------------
  // SAVE FUNCTIONS
  // -----------------------------

  const saveState = async () => {
    if (!stateName) return alert("Enter state name");
    await axios.post(`${API}/state`, { name: stateName });
    alert("State added!");
    setStateName("");
    fetchStates();
  };

  const saveDistrict = async () => {
    if (!selectedState || !districtName)
      return alert("Select state & enter district name");
    await axios.post(`${API}/district`, {
      state_id: selectedState,
      name: districtName,
    });
    alert("District added!");
    setDistrictName("");
    fetchDistricts(selectedState);
  };

  const saveBlock = async () => {
    if (!selectedDistrict || !blockName)
      return alert("Select district & enter block name");
    await axios.post(`${API}/block`, {
      district_id: selectedDistrict,
      name: blockName,
    });
    alert("Block added!");
    setBlockName("");
    fetchBlocks(selectedDistrict);
  };

  const savePanchayat = async () => {
    if (!selectedBlock || !panchayatName)
      return alert("Select block & enter panchayat name");
    await axios.post(`${API}/panchayat`, {
      block_id: selectedBlock,
      name: panchayatName,
    });
    alert("Panchayat added!");
    setPanchayatName("");
  };

  return (
    <div style={styles.container}>
      <h2>🌍 Administrative Geography Master</h2>

      {/* ADD STATE */}
      <div style={styles.section}>
        <h3>1️⃣ Add State</h3>
        <input
          placeholder="State Name"
          value={stateName}
          onChange={(e) => setStateName(e.target.value)}
          style={styles.input}
        />
        <button onClick={saveState} style={styles.btn}>Save State</button>
      </div>

      {/* ADD DISTRICT */}
      <div style={styles.section}>
        <h3>2️⃣ Add District</h3>

        <select
          value={selectedState}
          onChange={(e) => {
            setSelectedState(e.target.value);
            fetchDistricts(e.target.value);
          }}
          style={styles.select}
        >
          <option value="">-- Select State --</option>
          {states.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>

        <input
          placeholder="District Name"
          value={districtName}
          onChange={(e) => setDistrictName(e.target.value)}
          style={styles.input}
        />

        <button onClick={saveDistrict} style={styles.btn}>Save District</button>
      </div>

      {/* ADD BLOCK */}
      <div style={styles.section}>
        <h3>3️⃣ Add Block</h3>

        <select
          value={selectedDistrict}
          onChange={(e) => {
            setSelectedDistrict(e.target.value);
            fetchBlocks(e.target.value);
          }}
          style={styles.select}
        >
          <option value="">-- Select District --</option>
          {districts.map((d) => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>

        <input
          placeholder="Block Name"
          value={blockName}
          onChange={(e) => setBlockName(e.target.value)}
          style={styles.input}
        />

        <button onClick={saveBlock} style={styles.btn}>Save Block</button>
      </div>

      {/* ADD PANCHAYAT */}
      <div style={styles.section}>
        <h3>4️⃣ Add Panchayat</h3>

        <select
          value={selectedBlock}
          onChange={(e) => setSelectedBlock(e.target.value)}
          style={styles.select}
        >
          <option value="">-- Select Block --</option>
          {blocks.map((b) => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>

        <input
          placeholder="Panchayat Name"
          value={panchayatName}
          onChange={(e) => setPanchayatName(e.target.value)}
          style={styles.input}
        />

        <button onClick={savePanchayat} style={styles.btn}>Save Panchayat</button>
      </div>
    </div>
  );
}


// ----------------------------------------------------------
// INLINE CSS (Simple and Clear for Admin UI)
// ----------------------------------------------------------
const styles = {
  container: { padding: "20px", maxWidth: "700px", margin: "auto" },
  section: {
    border: "1px solid #ccc",
    padding: "15px",
    marginBottom: "20px",
    borderRadius: "5px",
  },
  input: {
    width: "60%",
    padding: "8px",
    marginRight: "10px",
  },
  select: {
    width: "60%",
    padding: "8px",
    marginBottom: "10px",
  },
  btn: {
    padding: "8px 12px",
    background: "#007bff",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "4px",
  },
};
